import gql from 'graphql-tag';

export const WITHDRAW = gql`
  mutation ($id: ID!) {
    withdrawApplication(id: $id) {
      status
    }
  }
`;
